import React, { Component } from 'react';
import { allFormats } from './mapComponent/coordinateFormats';

class MouseLocation extends Component {
  constructor(props) {
    super(props);
    this.state = { formats: [], showTip: false };
  }

  changeLocation(e) {
    const lat = e.lngLat.lat;
    const lng = e.lngLat.lng;
    this.setState({ formats: allFormats(lat, lng) });
  }

  renderRow(key, label, value) {
    const nbsp = '\u00a0';
    return (
      <div key={key} className="d-flex align-items-center">
        <span style={{ minWidth: '4rem' }}>{label}:</span>
        <span style={{ whiteSpace: 'nowrap' }}>{value || nbsp}</span>
      </div>
    );
  }

  render() {
    const { formats, showTip } = this.state;
    return (
      <div
        id="mouse-coordinates"
        className="p-2 mr-3"
        style={{
          width: 'max-content',
          minWidth: '18rem',
          fontVariantNumeric: 'tabular-nums'
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-1">
          <small className="text-muted" style={{ fontSize: '0.7rem' }}>
            Cursor position
          </small>
          <div style={{ position: 'relative', display: 'inline-flex' }}>
            <span
              className="material-icons ml-2 text-muted"
              style={{ fontSize: '14px', cursor: 'pointer' }}
              onMouseEnter={() => this.setState({ showTip: true })}
              onMouseLeave={() => this.setState({ showTip: false })}
            >
              info_outline
            </span>
            {showTip && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '120%',
                  right: 0,
                  width: '16rem',
                  background: 'rgba(0,0,0,0.75)',
                  color: '#fff',
                  fontSize: '0.72rem',
                  borderRadius: '4px',
                  padding: '6px 8px',
                  pointerEvents: 'none',
                  lineHeight: 1.4,
                  zIndex: 10
                }}
              >
                Right-click anywhere on the map to pin the coordinates at that
                location and copy them to the clipboard.
              </div>
            )}
          </div>
        </div>
        {formats.length === 0
          ? ['WGS84', 'DMS', 'DDM', 'UTM', 'MGRS'].map(label =>
              this.renderRow(label.toLowerCase(), label, null)
            )
          : formats.map(({ key, label, value }) =>
              this.renderRow(key, label, value)
            )}
      </div>
    );
  }
}

export default MouseLocation;
